module.exports = __webpack_public_path__ + "media/get-started/lines_2-4e0cf6a2.png";